<div *ngIf="loading$ | async" class="loading-container">
  <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
</div>
